import MyProfile from '../pages/MyProfile';
import MediakitPublicPage from '../pages/MediakitPublicPage';
import Rates from '../pages/Rates';
import Analytics from '../pages/Analytics';
import Requests from '../pages/Requests';
import Earnings from '../pages/Earnings';

interface IRoute {
  path: string;
  name: string;
  exact: boolean;
  component: any;
  props?: any;
};

const routes: IRoute[] = [
    {
        path: '/mediakit/profile/my-profile',
        name: 'My Profile',
        component: MyProfile,
        exact: true,
    },
    {
        path: '/mediakit/profile/rates',
        name: 'Rates',
        component: Rates,
        exact: true,
    },
    {
        path: '/mediakit/profile/analytics',
        name: 'Analytics',
        component: Analytics,
        exact: true,
    },
    {
        path: '/mediakit/profile/request',
        name: 'Request',
        component: Requests,
        exact: true,
    },
    {
        path: '/mediakit/profile/earnings',
        name: 'Earnings',
        component: Earnings,
        exact: true,
    },
];

const routePublic: IRoute[] = [
    {
        path: '/:username',
        name: 'Media kit',
        component: MediakitPublicPage,
        exact: true,
    },
];

export {routes, routePublic};
